import { Component, OnInit } from '@angular/core';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-docu-sign',
    templateUrl: './docu-sign.component.html',
    styleUrls: ['./docu-sign.component.css']
})
export class DocuSignComponent implements OnInit {

    public docuSignUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl('');
    public pdfData: any = '';
    public type: any = '';

    private applicationId: number;

    constructor(
        private connectionService: ConnectionService,
        public router: Router,
        private sanitizer: DomSanitizer
    ) {
        const navigation = this.router.getCurrentNavigation();
        if (navigation.extras.state) {
            this.applicationId = navigation.extras.state.applicationId;
        } else {
            this.router.navigateByUrl('/');
        }
    }

    ngOnInit() {
        this.getSignDocusign().then(
            (statesData: any) => { },
            (statesError: any) => { }
        );
    }

    getSignDocusign() {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(environment.gateway + 'signDocusign/' + this.applicationId + '/8', 'application/json').subscribe(
                (data: any) => {
                    this.docuSignUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.object);
                    this.pdfData = data.object.pdf;
                    this.type = 'dsign';
                    resolve(data);
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
    }

    renderPdf = function () {
        if (this.type == 'pdf') {
            var byteCharacters = atob(this.pdfData);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], { type: 'application/pdf;base64' });
            var fileURL = URL.createObjectURL(file);
            document.querySelector('#contractIframe')['src'] = fileURL;
        }
    };

}
